import { render, staticRenderFns } from "./BaseTextArea.vue?vue&type=template&id=b54a4854&scoped=true&"
import script from "./BaseTextArea.vue?vue&type=script&lang=js&"
export * from "./BaseTextArea.vue?vue&type=script&lang=js&"
import style0 from "./BaseTextArea.vue?vue&type=style&index=0&id=b54a4854&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54a4854",
  null
  
)

export default component.exports